var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"student-label shadow"},[_c('div',{staticClass:"label-color",class:'label-status'+_vm.status}),_c('div',[_vm._v(_vm._s(_vm.name))]),_c('div',{staticStyle:{"padding-right":"5px"}},[_vm._v(_vm._s(_vm.rate))])])}
var staticRenderFns = []

export { render, staticRenderFns }